<script setup>
    import { ref } from 'vue';
    import { useCommonStore } from '@/stores/common';

    const store = useCommonStore();
    const imgURL = ref(store.cloudfrontImgURL);
    const iconURL = ref(store.cloudfrontIconURL);
    const showFullIcon = ref(false);
    const pg = ref(window.location.pathname);
    const viewportWidth = ref(window.innerWidth);

    function showBookingIcon() {
        if(viewportWidth.value > 335) {
            showFullIcon.value = true;
        }
    }

    function hideBookingIcon() {
        showFullIcon.value = false;
    }

    function OpenBookingPage() {
        if(store.isProduction()) { gtag('event', 'book_call_floating'); }
        window.location.assign('/book-with-louise-challis');
    }
</script>

<template>
    <div v-if="pg !== '/book-with-louise-challis'" id="book-a-call-icon" @click="OpenBookingPage">
        <div v-if="showFullIcon" id="full-book-call-icon" v-on:mouseleave="hideBookingIcon" class="flex justify-between fade-target">
            <div class="flex items-center w-[150px]">
                <p class="inline"><img class="inline" :src="iconURL+'phone-icon.png'" alt="Phone">Book Your Introductory Call</p>
            </div>
            <div>
                <img class="booking-staff-img" :src="imgURL+'meet-the-team/Louise.jpg'" alt="Louise">
            </div>   
        </div>
        <div v-else id="inital-book-call-icon" v-on:mouseover="showBookingIcon">
            <div class="flex justify-center">
                <img :src="iconURL+'phone-icon.png'" alt="Phone">
            </div>  
            <div>
                <p>Book a Call</p>
            </div>   
        </div>
    </div>
</template>

<style lang="css" scoped>
    #book-a-call-icon {
        position: fixed;
        bottom: 30px;
        right: 35px;
        z-index: 3000;
        cursor: pointer;
    }
    #inital-book-call-icon {
        width: 86px;
        height: 86px;
        padding-top: 5px;
        border-radius: 45px;
        border: 2px solid var(--clarity-pure-white);
        background-color: var(--clarity-orange);
        box-shadow: 0px 5px 20px var(--clarity-grey);
        text-align: center;
    }
    #inital-book-call-icon p {
        margin: 0px;
        font-family: var(--clarity-font-family-arial);
        font-size: 16px;
        color: var(--clarity-pure-white);
        text-align: center;
    }
    #inital-book-call-icon img {
        vertical-align: bottom;
        width: 24px;
        height: 24px;
    }
    #full-book-call-icon {
        width: 300px;
        height: 90px;
        padding-left: 25px;
        border: 2px solid var(--clarity-pure-white);
        background-color: var(--clarity-orange);
        box-shadow: 0px 5px 20px var(--clarity-grey);
        border-radius: 45px;
        overflow: clip;
    }
    #full-book-call-icon p {
        font-family: var(--clarity-font-family-arial);
        font-size: 18px;
        color: var(--clarity-pure-white);
    }
    #full-book-call-icon img {
        vertical-align: bottom;
        width: 24px;
        height: 24px;
        margin-right: 5px;
    }
    .booking-staff-img {
        width: 98px !important;
        height: auto !important;
        margin-right: 0px !important;
    }

    .fade-target {
        opacity: 0;
        transition: opacity 0.3s ease-in;
    }
    .fade-target:hover {
        opacity: 1;
    }

    @media only screen and (max-width: 360px) {
        #book-a-call-icon {
            right: 10px;
        }
    }
</style>